module.exports = __webpack_public_path__ + "static/media/md-radio.f85bf3de.svg";